import React from "react"
import loadable from "@loadable/component"

const LazyTextEditor = loadable(() => import("./index.client"))

const TextEditor = (props) => <LazyTextEditor {...props} />

export default TextEditor
